import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import PendingTransaction from '../PendingTransaction'
import { task } from 'mobx-task'
import { AlertPort } from '../ports'
import { AlertState } from '../../../alerts/Alert'
import { PayoutReviewStore } from '../PayoutReviewStore'

/**
 * View model for cancelling a user transaction.
 */
export class CancelUserTransactionViewModel extends ModalViewModel {
  constructor(
    public transaction: PendingTransaction,
    private payoutReviewStore: PayoutReviewStore,
    private adapter: AlertPort,
    closingSignal?: ModalViewModelClosingSignal
  ) {
    super(closingSignal)
  }

  /**
   * Cancels the transaction.
   */
  cancelTransaction = task.resolved(async () => {
    await this.payoutReviewStore.cancelUserTransaction({
      transaction: this.transaction,
    })
    this.adapter
      .newAlert()
      .withState(AlertState.Success)
      .saying('Success!', 'The transaction was canceled.')
      .show()
    this.close()
  })
}
